import { CreditCard } from 'types/interfaces/CreditCard';
import { UserProfile } from 'types/interfaces/user/UserProfile';

import { CreditsFunnels } from 'helpers/funnels/funnels';

import { httpClient } from './httpClient';

export interface WelcomeGiftResponse {
  credits: number;
}

export interface CreditsRefillStatusPayload {
  enabled: boolean;
  refillPackageInfo?: string;
}
export interface CreditsInsufficientError {
  response: {
    data: {
      card: CreditCard | null;
      code: 'insufficient_funds';
      credits: number;
      error: string;
      refill_package_info: string | null;
      message_id: number;
    };
  };
}

export const CreditApi = {
  async getWelcomeGift(payload: { funnel: CreditsFunnels }) {
    const { data } = await httpClient.post<WelcomeGiftResponse>(
      '/credit/add/premium-gift',
      {
        funnel: payload.funnel,
      }
    );

    return data;
  },

  async unlockPopularUser(payload: { userId: number }) {
    const { data } = await httpClient.post<UserProfile>(
      `/credit/buy/profile-view/${payload.userId}`
    );

    return data;
  },

  async getBoost() {
    const { data } = await httpClient.post<{ credits: number }>(
      '/credit/buy/boost'
    );

    return data;
  },

  async unlockPrivateVideo(payload: { videoId: number }) {
    return httpClient.post(
      `/credit/buy/watch-private-video/${payload.videoId}`
    );
  },

  async fetchCreditsRefillStatus() {
    const { data } = await httpClient.get<{ enabled: boolean }>(
      '/credit/settings/refill'
    );

    return data;
  },

  async updateCreditsRefillStatus(payload: CreditsRefillStatusPayload) {
    const { data } = await httpClient.post<{ enabled: boolean }>(
      '/credit/settings/refill',
      {
        enabled: payload.enabled,
        ...(payload.refillPackageInfo && {
          refill_package_info: payload.refillPackageInfo,
        }),
      }
    );

    return data;
  },
};
